/**
 * Mirrors the backend enum `Core.Standard/Enums/Config/AI/Agents/AIAgentVersionOperation.cs`.
 *
 * The C# definition uses `[EnumMember(Value = "...")]` so the JSON payload
 * exposes kebab-case strings, but the numeric values are kept here so we can
 * use this enum in OData filter payloads (`agentBuilder` traces drawer), in
 * dropdowns, and as the single source of truth for the new-version /
 * change-current-version operations that aren't in `DynamicEntityVersionOperation`.
 */
export default Object.freeze({
  GenerateTokenReadOnly: 1, // "generate-token-readonly"
  GenerateTokenWrite: 2, // "generate-token-write"
  AppendComponent: 3, // "append-component"
  ModifyComponent: 4, // "modify-component"
  RemoveComponent: 5, // "remove-component"
  Publish: 6, // "publish"
  NewVersionCreated: 7, // "new-version-created"
  ChangeCurrentVersion: 8, // "change-current-version"
});
